import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from 'react-router-dom';

const sessionDetails = () => {
    return sessionStorage.getItem(`userDetails`);
    //return true;
  };

const PrivateRoute = ({ children }) => {
    const [auth, setAuth] = useState(false);

    const tokenData = sessionDetails();
    return tokenData ? (children ): <Navigate to="/login" />;
}

export default PrivateRoute;